export const environment = {
  APP_ROOT: "/",
  API_ROOT: "http://localhost:8080/api",
  SOCKET_HOST: "http://localhost",
  SOCKET_PORT: 8080,
};



/** WEBPACK FOOTER **
 ** ./src/environments/environment.js
 **/